import { makeStyles } from '@material-ui/core';
import React from 'react';
const useHubManagementStyles = makeStyles((theme: any) => ({
    container1: (props: any) => ({
        height: 'calc(100vh - 90px)',
        //overflowY: 'auto',
        //overflowX: 'auto',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
    }),
    card: {
        backgroundColor: '#f6f7f9',
        marginTop: 16,
        color: '#000',
        padding: 16,
    },
    routeContainer: {
        padding: '12px 12px',
        paddingBottom: 0,
    },
    backIcon: {
        minWidth: '0',
        color: '#000000',
        cursor: 'pointer',
        marginRight: '8px',
    },
    scrollableBox: {
        width: '100%',
        height: '38vh',
        overflowY: 'auto',
        minHeight: '38vh',
        maxHeight: '38vh',
        marginTop: 12,
        borderRadius: 16,
    },
    tableContainer: {
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        paddingRight: '8px',
        minHeight: 'calc(100vh - 236px)',
        maxHeight: 'calc(100vh - 236px)',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
    },
    filterContainer: {
        marginBottom: 12,
        padding: '12px 12px',
    },
    container: (props: any) => ({
        //overflowY: 'auto',
        //overflowX: 'auto',
        // overflow: 'auto',
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        // },
        // '&::-webkit-scrollbar-track': {
        //     background: '#f1f1f1',
        //     borderRadius: '8px',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     background: '#888',
        //     borderRadius: '8px',
        // },
        // '&::-webkit-scrollbar-thumb:hover': {
        //     background: '#555',
        // },
    }),
    filterBox: {
        width: 'auto',
        height: 'auto',
        minWidth: 160,
        minHeight: 112,
        boxShadow: 'none',
        padding: '12px 16px',
        border: '1px solid #EBEDF8',
        borderRadius: '4px',
        backgroundColor: '#F6F7F9',
        cursor: 'pointer',
    },
    cardHeader: {
        fontSize: '16px',
        fontWeight: 600,
    },
    cardSubHeader: {
        fontSize: '22px',
        fontWeight: 700,
        marginTop: '16px',
    },
    tableTLContainer: {
        width: '100%',
        height: '100%',
        overflowY: 'auto',
        paddingRight: '8px',
        minHeight: 'calc(100vh - 447px)',
        maxHeight: 'calc(100vh - 447px)',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
    },
    // --- Toolbar -----------------------------------------------------------
    toolbar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 8,
        padding: '10px 12px',
        borderRadius: 10,
        backgroundColor: '#fafbff',
        border: '1px solid #ebedf8',
    },
    // Matches vendor-management's primary CTA so Add Hub sits consistently beside the two
    // outlined bulk buttons.
    primaryButton: {
        textTransform: 'none',
        fontWeight: 700,
        fontSize: 14,
        borderRadius: 8,
        padding: '6px 18px',
        backgroundColor: '#43419e',
        color: '#fff',
        whiteSpace: 'nowrap',
        '&:hover': { backgroundColor: '#37357f' },
        '&.Mui-disabled': { backgroundColor: '#d5d7e8', color: '#fff' },
    },
    outlinedButton: {
        textTransform: 'none',
        fontWeight: 700,
        fontSize: 14,
        borderRadius: 8,
        padding: '6px 14px',
        borderColor: '#d5d7e8',
        color: '#43419e',
        backgroundColor: '#fff',
        whiteSpace: 'nowrap',
        '&:hover': {
            borderColor: '#43419e',
            backgroundColor: '#f5f6ff',
        },
    },
    ghostButton: {
        textTransform: 'none',
        fontWeight: 700,
        fontSize: 14,
        borderRadius: 8,
        padding: '6px 12px',
        color: '#515f6d',
        '&:hover': { backgroundColor: '#eceef8' },
    },
    resultSummary: {
        fontSize: 13,
        fontWeight: 700,
        color: '#515f6d',
        whiteSpace: 'nowrap',
    },
    tableRow: {
        transition: 'background-color 0.15s ease-in-out',
        '&:hover': {
            backgroundColor: '#f7f8ff',
        },
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        minHeight: 220,
    },
    emptyTitle: {
        fontSize: 16,
        fontWeight: 700,
        color: '#14112d',
    },
    emptySubtitle: {
        fontSize: 14,
        fontWeight: 600,
        color: '#8a92a6',
    },
    // --- Table -------------------------------------------------------------
    // break-word instead of break-all so hub names and store IDs don't split
    // mid-token, and 14px to match the denser header.
    tableValue: {
        wordBreak: 'break-word',
        fontWeight: 600,
        fontSize: 14,
        color: '#14112D',
    },
    tableSubValue: {
        wordBreak: 'break-all',
        fontWeight: 400,
        fontSize: 14,
        marginTop: '6px',
        color: '#14112D',
    },
    tableValueBold: {
        wordBreak: 'break-all',
        fontWeight: 700,
        fontSize: 16,
    },
    chip: {
        fontSize: 12,
        width: 'auto',
        color: ' #fff',
        border: '1px solid #fff',
        borderRadius: '8px',
        padding: '2px 12px',
        //margin: '0px 8px',
        textAlign: 'center',
        backgroundColor: 'black',
    },
    chipText: {
        fontSize: 12,
        color: 'inherit',
    },
    peak: {
        backgroundColor: '#F4EBFC !important',
        border: '1px solid #43419E !important',
        color: '#43419E !important',
    },
    normal: {
        backgroundColor: '#F4EBFC !important',
        border: '1px solid #43419E !important',
        color: '#43419E !important',
    },
    menu: {
        border: '1px solid #3f51b5',
        color: ' #3f51b5',
        borderRadius: 8,
        padding: '8px',
    },
    paginationContainer: {},
    cardCX: {
        borderRadius: 8,
        border: '1px solid #EAEAEA',
        background: '#FFF',
    },
}));
export default useHubManagementStyles;
